import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function getFormCate() {
  return _getFormCate.apply(this, arguments);
}
function _getFormCate() {
  _getFormCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/form/getFormCate', METHOD.POST, {}));
      }
    }, _callee);
  }));
  return _getFormCate.apply(this, arguments);
}
export function addFormDetail(_x) {
  return _addFormDetail.apply(this, arguments);
}
function _addFormDetail() {
  _addFormDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/form/addFormDetail', METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _addFormDetail.apply(this, arguments);
}
export function updateFormDetail(_x2) {
  return _updateFormDetail.apply(this, arguments);
}
function _updateFormDetail() {
  _updateFormDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request('/form/updateFormDetail', METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _updateFormDetail.apply(this, arguments);
}
export function queryFormDetails(_x3) {
  return _queryFormDetails.apply(this, arguments);
}
function _queryFormDetails() {
  _queryFormDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request('/form/queryFormDetails', METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _queryFormDetails.apply(this, arguments);
}
export function addFormDetailDesign(_x4) {
  return _addFormDetailDesign.apply(this, arguments);
}
function _addFormDetailDesign() {
  _addFormDetailDesign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request('/form/addFormDetailDesign', METHOD.POST, data));
      }
    }, _callee5);
  }));
  return _addFormDetailDesign.apply(this, arguments);
}
export function updateFormDetailsUseStatus(_x5) {
  return _updateFormDetailsUseStatus.apply(this, arguments);
}
function _updateFormDetailsUseStatus() {
  _updateFormDetailsUseStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request('/form/updateFormDetailsUseStatus', METHOD.POST, data));
      }
    }, _callee6);
  }));
  return _updateFormDetailsUseStatus.apply(this, arguments);
}
export function saveAll(_x6) {
  return _saveAll.apply(this, arguments);
}
function _saveAll() {
  _saveAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request('/form/saveAll', METHOD.POST, data));
      }
    }, _callee7);
  }));
  return _saveAll.apply(this, arguments);
}
export function getFormDetailDesign(_x7) {
  return _getFormDetailDesign.apply(this, arguments);
}
function _getFormDetailDesign() {
  _getFormDetailDesign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request('/form/getFormDetailDesign', METHOD.POST, data));
      }
    }, _callee8);
  }));
  return _getFormDetailDesign.apply(this, arguments);
}
export function queryFormButtonList() {
  return _queryFormButtonList.apply(this, arguments);
}
function _queryFormButtonList() {
  _queryFormButtonList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request('/form/queryFormButtonList', METHOD.POST));
      }
    }, _callee9);
  }));
  return _queryFormButtonList.apply(this, arguments);
}
export function getAllOrgan(_x8) {
  return _getAllOrgan.apply(this, arguments);
}
function _getAllOrgan() {
  _getAllOrgan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(data) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request('/form/getAllOrgan', METHOD.POST, data));
      }
    }, _callee0);
  }));
  return _getAllOrgan.apply(this, arguments);
}
export function queryFormFillById(_x9) {
  return _queryFormFillById.apply(this, arguments);
}
function _queryFormFillById() {
  _queryFormFillById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request('/form/queryFormFillById', METHOD.GET, data));
      }
    }, _callee1);
  }));
  return _queryFormFillById.apply(this, arguments);
}
export function queryFormFillByProcInsId(_x0) {
  return _queryFormFillByProcInsId.apply(this, arguments);
}
function _queryFormFillByProcInsId() {
  _queryFormFillByProcInsId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(data) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request('/form/queryFormFillByProcInsId', METHOD.GET, data));
      }
    }, _callee10);
  }));
  return _queryFormFillByProcInsId.apply(this, arguments);
}
export function printFormTemplate(_x1) {
  return _printFormTemplate.apply(this, arguments);
}

/****
 * flowable 相关
 */
function _printFormTemplate() {
  _printFormTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request('/form/printFormTemplate', METHOD.POST, data));
      }
    }, _callee11);
  }));
  return _printFormTemplate.apply(this, arguments);
}
export function queryWaitMeApplys(_x10) {
  return _queryWaitMeApplys.apply(this, arguments);
}
function _queryWaitMeApplys() {
  _queryWaitMeApplys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(data) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request('/flowable/task/todoList', METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _queryWaitMeApplys.apply(this, arguments);
}
export function queryAfterMeApplys(_x11) {
  return _queryAfterMeApplys.apply(this, arguments);
}
function _queryAfterMeApplys() {
  _queryAfterMeApplys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request('/flowable/task/finishedList', METHOD.POST, data));
      }
    }, _callee13);
  }));
  return _queryAfterMeApplys.apply(this, arguments);
}
export function queryAbnormalApplys(_x12) {
  return _queryAbnormalApplys.apply(this, arguments);
}
function _queryAbnormalApplys() {
  _queryAbnormalApplys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request('/flowable/task/abNormalList', METHOD.POST, data));
      }
    }, _callee14);
  }));
  return _queryAbnormalApplys.apply(this, arguments);
}
export function getFlowRecordById(_x13) {
  return _getFlowRecordById.apply(this, arguments);
}
function _getFlowRecordById() {
  _getFlowRecordById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request('/flowable/task/flowRecord', METHOD.GET, {
            processInstanceId: data
          }));
      }
    }, _callee15);
  }));
  return _getFlowRecordById.apply(this, arguments);
}
export function complete(_x14) {
  return _complete.apply(this, arguments);
}
function _complete() {
  _complete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(data) {
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          return _context16.a(2, request('/flowable/task/complete', METHOD.POST, data));
      }
    }, _callee16);
  }));
  return _complete.apply(this, arguments);
}
export function taskReturn(_x15) {
  return _taskReturn.apply(this, arguments);
}
function _taskReturn() {
  _taskReturn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(data) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, request('/flowable/task/taskReturn', METHOD.POST, data));
      }
    }, _callee17);
  }));
  return _taskReturn.apply(this, arguments);
}
export function taskReject(_x16) {
  return _taskReject.apply(this, arguments);
}
function _taskReject() {
  _taskReject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(data) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, request('/flowable/task/taskReject', METHOD.POST, data));
      }
    }, _callee18);
  }));
  return _taskReject.apply(this, arguments);
}
export function nextFlowNode(_x17) {
  return _nextFlowNode.apply(this, arguments);
}
function _nextFlowNode() {
  _nextFlowNode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(data) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, request('/flowable/task/nextFlowNode', METHOD.POST, data));
      }
    }, _callee19);
  }));
  return _nextFlowNode.apply(this, arguments);
}
export function stopProcess(_x18) {
  return _stopProcess.apply(this, arguments);
}
function _stopProcess() {
  _stopProcess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(data) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, request('/flowable/task/stopProcess', METHOD.POST, data));
      }
    }, _callee20);
  }));
  return _stopProcess.apply(this, arguments);
}
export function revokeProcess(_x19) {
  return _revokeProcess.apply(this, arguments);
}
function _revokeProcess() {
  _revokeProcess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(data) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, request('/flowable/task/revokeProcess', METHOD.POST, data));
      }
    }, _callee21);
  }));
  return _revokeProcess.apply(this, arguments);
}
export function queryOP(_x20) {
  return _queryOP.apply(this, arguments);
}
function _queryOP() {
  _queryOP = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(data) {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, request('/common/queryOP', METHOD.GET, data));
      }
    }, _callee22);
  }));
  return _queryOP.apply(this, arguments);
}
export function getOrganPostTreeByOrganId(_x21) {
  return _getOrganPostTreeByOrganId.apply(this, arguments);
}

// 读取xml文件
function _getOrganPostTreeByOrganId() {
  _getOrganPostTreeByOrganId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(data) {
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          return _context23.a(2, request('/userInfo/getOrganPostTreeByOrganId', METHOD.GET, data));
      }
    }, _callee23);
  }));
  return _getOrganPostTreeByOrganId.apply(this, arguments);
}
export function readXml(deployId) {
  return request({
    url: '/flowable/definition/readXml/' + deployId,
    method: 'get'
  });
}
// 读取image文件
export function readImage(deployId) {
  return request({
    url: '/flowable/definition/readImage/' + deployId,
    method: 'get'
  });
}

// 读取image文件
export function getFlowViewer(procInsId) {
  return request({
    url: '/flowable/task/flowViewer/' + procInsId,
    method: 'get'
  });
}
export function queryFlowTrackList(_x22, _x23, _x24) {
  return _queryFlowTrackList.apply(this, arguments);
}
function _queryFlowTrackList() {
  _queryFlowTrackList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(page, limit, param) {
    var data;
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit,
            formName: param.formName,
            category: param.category,
            processStatus: param.processStatusName,
            startTime: param.startTime,
            endTime: param.endTime,
            summary: param.summary,
            fillId: param.fillId
            // isRead: param.isRead,
            // cateName: param.type,
            // formName: param.formName
          };
          return _context24.a(2, request('/flow/queryFlowTrackList', METHOD.GET, data));
      }
    }, _callee24);
  }));
  return _queryFlowTrackList.apply(this, arguments);
}
export function saveFlowTrack(_x25) {
  return _saveFlowTrack.apply(this, arguments);
}
function _saveFlowTrack() {
  _saveFlowTrack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(data) {
    var id;
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          id = {
            processInstanceId: data.processInstanceId || data.procInsId
          };
          return _context25.a(2, request('/flow/saveFlowTrack', METHOD.GET, id));
      }
    }, _callee25);
  }));
  return _saveFlowTrack.apply(this, arguments);
}
export function formPrintById(_x26) {
  return _formPrintById.apply(this, arguments);
}

/**
 * 组织及岗位的数据过滤
 */
function _formPrintById() {
  _formPrintById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(data) {
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          return _context26.a(2, request('formPrint/formPrintById', METHOD.POST, data));
      }
    }, _callee26);
  }));
  return _formPrintById.apply(this, arguments);
}
export function getWormingScope(_x27) {
  return _getWormingScope.apply(this, arguments);
}
function _getWormingScope() {
  _getWormingScope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(data) {
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          return _context27.a(2, request('form/getWormingScope', METHOD.POST, data));
      }
    }, _callee27);
  }));
  return _getWormingScope.apply(this, arguments);
}
export default {
  getFormCate: getFormCate,
  addFormDetail: addFormDetail,
  queryFormDetails: queryFormDetails,
  addFormDetailDesign: addFormDetailDesign,
  updateFormDetailsUseStatus: updateFormDetailsUseStatus,
  saveAll: saveAll,
  queryOP: queryOP,
  queryFormFillById: queryFormFillById,
  formPrintById: formPrintById,
  getWormingScope: getWormingScope
};